/* eslint-disable no-empty-pattern */
import { increment } from 'vuex-easy-firestore';
import { arrayRemove } from 'vuex-easy-firestore';
import uuidv1 from 'uuid/v1';
import fb from '../../../firebaseConfig';
import { has } from 'lodash';
import helpers from './helpers';
import generateThumb from './utils/generateThumb';
import axios from 'axios';
import * as exifr from 'exifr/dist/lite.esm.js';

const resourcesModules = {
  //  Easy VUEX firestore configuration
  firestorePath: 'resources',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'resources',
  statePropName: 'resources',
  namespaced: true, // automatically added
  state: {},
  getters: {
    contextResources: (state, getters, rootState, rootGetters) => {
      const context = rootGetters['context/context'];
      return Object.values(state.resources).filter(r => !!r.usedOn[context.id]);
    },
    resourcesByCategory: (state, getters, rootState, rootGetters) => {
      const context = rootGetters['context/context'];
      const categories = context.researchCategories
        ? Object.values(context.researchCategories)
        : [];
      const categoryIds = [];
      categories.map(c => {
        const research = c.resourceIds.map(r => {
          categoryIds.push(r);
          return state.resources[r];
        });
        return { ...c, research };
      });
      const uncategorized = getters.contextResources.filter(r => !categoryIds.includes(r.id));
      categories.push({ name: 'Uncategorized', id: 'uncat', research: uncategorized });
      return categories;
    }
  },
  mutations: {},
  actions: {
    subscribeToContextResources({ dispatch }, { contextId }) {
      if (!contextId) {
        throw 'no id was provided for the context to which you want to subscribe to its resources';
      }

      try {
        //dispatch('openDBChannel');
        dispatch('openDBChannel', { where: [[`usedOn.${contextId}.id`, '==', contextId]] });
      } catch (e) {
        console.log(`problem subscribing to resources where context == id: ${contextId}`, e);
      }
    },
    async subscribeToResource({ dispatch, state }, { resourceId }) {
      if (!resourceId) {
        throw new Error(
          'no resourceId was provided for the resource to which you want to subscribe to'
        );
      }
      console.log('state', state);
      try {
        const result = await dispatch('openDBChannel', {
          where: [[fb.firestore.FieldPath.documentId(), '==', resourceId]]
        });
        return result;
      } catch (e) {
        throw new Error('error subscribing to resource', e);
      }
    },
    unsubscribeToContextResources({ dispatch }) {
      dispatch('closeDBChannel', { clearModule: true });
    },
    async uploadResourceFile({}, { workspaceId, file, dir, ext, type = 'file' }) {
      //  file is the file to upload
      //  dir is the directory
      console.log('uploading file');
      //  Upload the file
      const fileId = uuidv1();
      const path = `${workspaceId}/${dir}/${fileId}.${ext}`;

      try {
        const storageRef = fb.storage.ref();
        const fileRef = storageRef.child(path);
        if (type == 'file') {
          await fileRef.put(file);
        } else if (type == 'string') {
          console.log('putstring');
          await fileRef.putString(file, 'data_url');
        }
        console.log('uploaded');
        return { path, fileRef };
      } catch (e) {
        throw new Error('Error uploading file', e);
      }
    },
    async createNewResource({ rootGetters, dispatch }, { type, url, file }) {
      const userId = rootGetters['auth/userId'];
      const userProfile = rootGetters['auth/profile'];
      let resourceType = type;
      userProfile.id = userId;
      //const workspaceTags = rootGetters['workspaces/selectedWorkspaceTags'];
      //const selectedTags = rootState.workspaces.tagsForContext;
      const selectedWorkspace = rootGetters['workspaces/currentWorkspace'];
      const selectedContext = rootGetters['context/context'];
      //console.log('workspaceTags', workspaceTags);
      //onsole.log('selectedTags', selectedTags);
      console.log('selectedWorkspace', selectedWorkspace);
      console.log('selectedContext', selectedContext);

      //if context is a string then fetch the context will be used for 'used on' and for editing
      const context = selectedContext ? selectedContext : null;

      console.log('context', context);
      let resourceData;
      //  build resourceData

      //  If URL go fetch the metadata
      let text;
      if (url != undefined) {
        //  Fetch the meta data
        try {
          console.log('fetch from url');
          const sourceData = await dispatch('fetchMetadataFromUrl', url);
          if (sourceData.type && sourceData.type.includes('image')) {
            resourceType = 'image';
          } else if (sourceData.type && sourceData.type.includes('pdf')) {
            resourceType = 'pdf';
          }
          resourceData = sourceData;
          resourceData.webpageHtmlRef = 'fetching';
          text = sourceData.title || sourceData.url;
        } catch (e) {
          console.log('failed to fetch resource', e);
          throw new Error('failed to fetch resource', e);
        }
      } else if (file != undefined) {
        console.log('is file');
        if (file == undefined || typeof file != 'object') {
          throw new Error('no or incorrect file was provided for the resource');
        }

        if (type == 'pdf') {
          if (file.type != 'application/pdf') {
            throw new Error('Tried to upload pdf but file was not pdf');
          }
        } else if (type == 'image') {
          const acceptedImageTypes = ['image/png', 'image/jpeg', 'image/bmp'];

          if (!acceptedImageTypes.includes(file.type)) {
            throw new Error(
              'Tried to upload image but file was not acceptable image. Was: ',
              file.type
            );
          }

          //  Check Picture Orientation
          let exifData = await exifr.orientation(file, { translateValues: false });
          console.log(exifData);
          return;
        } else {
          throw new Error(
            'Tried to upload file but type was not image or pdf resource but file not pdf'
          );
        }

        const { path, fileRef } = await dispatch('uploadResourceFile', {
          workspaceId: selectedWorkspace.id,
          file,
          dir: type + 's',
          ext: type
        });
        const downloadUrl = await fileRef.getDownloadURL();

        //  create a thumbnail
        let thumbnailRef = null;
        let thumbnailUrl = null;
        const thumbnailFile = await generateThumb(file);
        if (thumbnailFile) {
          const thumbnail = await dispatch('uploadResourceFile', {
            workspaceId: selectedWorkspace.id,
            file: thumbnailFile,
            dir: type + 's',
            ext: 'jpg',
            type: 'string'
          });

          thumbnailRef = thumbnail.path;
          thumbnailUrl = await thumbnail.fileRef.getDownloadURL();
        }

        text = file.name;
        resourceData = {
          lastModifiedDate: file.lastModifiedDate,
          name: file.name,
          size: file.size,
          type,
          fileRef: path,
          downloadUrl,
          thumbnailRef,
          thumbnailUrl
        };
      }

      // //create a new tags object which will contain all the tags for this and generate new Id's for any that are not currently in the workspace
      // const tagsObject = {};
      // selectedTags.forEach(selectedTag => {
      //   const tagOfInterest = workspaceTags.find(workspaceTag => workspaceTag.text === selectedTag);
      //   if (tagOfInterest === undefined) {
      //     const tagId = fb.resourcesCollection.doc().id;
      //     const newTagObj = {
      //       id: tagId,
      //       text: selectedTag
      //     };
      //     tagsObject[newTagObj.id] = newTagObj;
      //   } else {
      //     delete tagOfInterest.resources;
      //     tagsObject[tagOfInterest.id] = tagOfInterest;
      //   }
      // });

      const resourceDoc = {
        usedOn: {},
        createdBy: userId,
        createdOn: new Date(),
        updatedOn: new Date(),
        version: 1,
        authors: {},
        text,
        workspace: selectedWorkspace.id,
        permissions: {
          discoverable: 'workspace',
          editing: [selectedWorkspace.id],
          cloneable: true
        },
        tags: {
          userDefined: {},
          metadataDefined: 'keywords' in resourceData ? resourceData.keywords : []
        },
        resourceData,
        cloned: {},
        noteBlocks: {}
      };

      //get authors from context if available or just set author to current user
      if (context !== null && 'authors' in context) {
        resourceDoc.authors = context.authors;
      } else {
        resourceDoc.authors[userId] = userProfile;
      }

      //if there is editing available in context then use that for editing permissions
      if (
        context !== null &&
        'permissions' in context &&
        'editing' in context.permissions &&
        context.permissions.editing.length > 0
      ) {
        resourceDoc.permissions.editing = context.permissions.editing;
      }

      //if context exists then use it to update usedOn
      if (context !== null) {
        resourceDoc.usedOn[context.id] = {
          id: context.id,
          type: 'context',
          version: 1,
          public: false,
          pages: [],
          text: context.text,
          authors: context.authors
        };
      }

      console.log('resourceDoc', resourceDoc);
      try {
        const resourceId = await dispatch('insert', resourceDoc);
        //  Fetch the freeze-dried html if it's a webpage
        if (resourceType == 'webpage') {
          resourceDoc.id = resourceId;
          dispatch('updateResourceSource', { resource: resourceDoc });
        }
        return resourceId;
      } catch (e) {
        console.log(e);
        throw Error('Error inserting the resource', e);
      }
    },
    deleteResource({ dispatch }, { resourceId }) {
      //get the id's that we will need
      if (resourceId == undefined) {
        throw 'no id was provided for the resource';
      }
      //remove from vuex before anything else
      dispatch(
        'userWorkspaceLite/removeDocWorkspaceLiteVuexOnly',
        { docId: resourceId },
        { root: true }
      );
      dispatch('delete', resourceId);
    },
    async fetchMetadataFromUrl({}, fetchURL) {
      console.log('start fetch metadata');
      //  url and data which will be used for axios to get the website metadata
      const fetchSourceGCFURL = fb.paths.function + 'fetchUrlMetadata';
      //const fetchSourceGCFURL = fb.paths.functionLocal + 'fetchUrlMetadata';
      const data = {
        url: fetchURL
      };
      let sourceData = {
        url: fetchURL
      };
      //only run in URL is not blank
      if (fetchURL !== '') {
        try {
          //if you fail to get the metadata just set metadata for url to the provided url
          const metadata = await axios.post(fetchSourceGCFURL, data);
          if (metadata.data) {
            sourceData = metadata.data;
          }
          console.log(metadata);
        } catch (error) {
          console.log(error);
          throw new Error('error fetching url data', error);
        }
        console.log('got url data!');
        console.log('sourceData', sourceData);
        return sourceData;
      } else {
        throw new Error('error: no fetch url');
      }
    },
    async addResourceToContext({ dispatch, rootState }, { resourceId, context, contextId }) {
      //make sure necessary items are sent
      if (!resourceId) {
        throw new Error('no resource id provided');
      }
      if (!context && !contextId) {
        throw new Error('no context was provided');
      }
      let c;
      if (!context) {
        c = rootState.context.contextData[contextId];
        if (!c) {
          try {
            const cRef = await fb.contextsCollection.get(contextId);
            c = cRef.data();
          } catch (e) {
            console.log(e);
            throw new Error('No access to context');
          }
        }
      } else {
        c = context;
      }
      console.log(c);
      //create the update object
      const update = { id: resourceId, usedOn: {} };
      update['usedOn'][c.id] = {
        id: context.id,
        type: 'context',
        version: 1,
        public: false,
        pages: [],
        text: c.text,
        authors: c.authors
      };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', update);
      return true;
    },
    removeResourceFromContext({ dispatch, rootState }, { resourceId, contextId }) {
      //get the id's that we will need
      if (resourceId == undefined) {
        throw new Error('no resourceId was provided for the resource');
      }
      if (contextId == undefined) {
        throw new Error('no contextId was provided');
      }
      if (rootState.context.subscribedId !== contextId) {
        const errorText =
          'currently not subscribed to the contextId you are requesting to update. you can only remove a resource from a context that is currently open.';
        throw new Error(errorText);
      }

      const pagesArray = Object.values(rootState.pages.pages);
      pagesArray.forEach(page => {
        const pageUpdate = {};
        pageUpdate.id = page.id;
        pageUpdate['syncIds'] = arrayRemove(resourceId);
        const noteBlocks = Object.values(page.noteBlocks);
        let noteBlockShiftDistance = 0;
        noteBlocks
          .sort((a, b) => a.order - b.order)
          .forEach(noteBlock => {
            //if the noteblock has relation to the resource than delete it otherwise modify the order to match how many have been deleted
            if (
              has(noteBlock, 'content.widgetData.resourceId') &&
              noteBlock.content.widgetData.resourceId === resourceId
            ) {
              //delete the noteblock and increment the noteblock shift ticker
              noteBlockShiftDistance += 1;
              if (!('noteBlocks' in pageUpdate)) {
                pageUpdate.noteBlocks = {};
              }
              pageUpdate.notesToDelete = true;
              pageUpdate.noteBlocks[noteBlock.id] = { toDelete: true };
            } else {
              //shift the order by the number of previous deletions
              if (noteBlockShiftDistance > 0) {
                if (!('noteBlocks' in pageUpdate)) {
                  pageUpdate.noteBlocks = {};
                }
                pageUpdate.noteBlocks[noteBlock.id] = {
                  order: increment(-1 * noteBlockShiftDistance)
                };
              }
            }
          });
        dispatch('pages/patch', pageUpdate);
        dispatch('batchSync');
      });

      //remove from used on
      dispatch('delete', `${resourceId}.usedOn.${contextId}`);
    },
    async addNoteBlock(
      { dispatch, getters, rootState, state },
      { resourceId, content, order = undefined, type = 'note' }
    ) {
      //throw an error if anythin is missing
      if (content == undefined) {
        throw 'no content field was provided for the new note';
      }
      if (order !== undefined && isNaN(order)) {
        throw 'the order provided is not a number';
      }
      if (resourceId == undefined) {
        throw 'no resourceId was provided for the new note';
      }

      // get the note blocks to determine last item order and to update order later
      const { resources } = state;
      const resource = resources[resourceId];
      const { noteBlocks } = resource;

      const newOrder = order !== undefined ? order : Object.keys(noteBlocks).length;

      //get necessary Id's (generated for new Id and user ID for created by)
      const id = getters['dbRef'].doc().id;
      const userId = rootState.auth.currentUser.uid;

      //create the update object for the addition of the note
      const noteUpdate = {};
      noteUpdate[id] = {
        id,
        createdBy: userId,
        createdOn: new Date(),
        order: newOrder,
        toDelete: false,
        type: type,
        content
      };

      // //update all the other notes that have a greater order than the one being added to be +1
      // Object.values(noteBlocks).forEach(noteBlock => {
      //   if (noteBlock.order >= newOrder) {
      //     noteUpdate[noteBlock.id] = {
      //       order: increment(1)
      //     };
      //   }
      // });

      console.log('noteUpdate', noteUpdate);
      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: resourceId, noteBlocks: noteUpdate });
      dispatch('batchSync');
      return id;
    },
    async addScreenShotExcerpt({ rootGetters, dispatch }, { resourceId, excerptData, source }) {
      //  Upload the image
      const { imageUrl, position = false, positions = [], pages = false } = excerptData;
      const selectedWorkspace = rootGetters['workspaces/currentWorkspace'];
      const { path, fileRef } = await dispatch('uploadResourceFile', {
        workspaceId: selectedWorkspace.id,
        file: imageUrl,
        dir: 'excerpts',
        ext: 'png',
        type: 'string'
      });
      const downloadUrl = await fileRef.getDownloadURL();
      const content = {
        widgetData: {
          imageRef: path,
          downloadUrl,
          source,
          position,
          positions,
          pages,
          title: 'My Screenshot',
          verifyImageRef: null
        },
        widgetType: 'imageExcerpt'
      };
      const id = await dispatch('addNoteBlock', { resourceId, content, type: 'widget' });
      console.log('return id', id);
      return id;
    },
    async addExcerpt(
      { dispatch },
      { resourceId, excerpt, source, position =  false, positions, pages, order }
    ) {
      const content = {
        widgetData: {
          excerpt,
          source,
          position,
          positions,
          pages,
          order,
          verificationStatus: 'fail',
          verifyImageRef: null
        },
        widgetType: 'textExcerpt'
      };
      const id = await dispatch('addNoteBlock', { resourceId, content, type: 'widget' });
      return id;
    },
    async addNote({ dispatch }, { resourceId, title, text, refNotes = [] }) {
      const content = {
        title,
        text,
        refNotes
      };
      const id = await dispatch('addNoteBlock', { resourceId, content, type: 'note' });
      return id;
    },
    updateNote({ dispatch }, { resourceId, noteId, update }) {
      //  update should be { content: { text, title, refNotes }}
      const noteBlocks = {};
      noteBlocks[noteId] = update;
      dispatch('patch', { id: resourceId, noteBlocks });
    },
    deleteResourceNoteBlock({ state, dispatch }, { noteBlockId, resourceId }) {
      console.log('remove note', noteBlockId);
      //get necessary Id's
      if (!noteBlockId) {
        throw 'no NoteBlockId was provided for the note you want to remove';
      }
      if (!resourceId) {
        throw 'no pageId was provided for the note you want to remove';
      }

      //find it's order and update all the ones with order greater than it
      const { resources } = state;
      const resource = resources[resourceId];
      const { noteBlocks } = resource;
      const currentNoteBlock = noteBlocks[noteBlockId];
      const { order } = currentNoteBlock;
      const update = { id: resourceId, noteBlocks: {}, notesToDelete: true };
      Object.values(noteBlocks).forEach(noteBlock => {
        if (noteBlock.order > order) {
          update.noteBlocks[noteBlock.id] = {
            order: increment(-1)
          };
        }
      });

      update.noteBlocks[noteBlockId] = { toDelete: true };

      //update the orders if the object length is not 0
      dispatch('patch', update);
    },
    updateNoteBlockHTML({ dispatch }, { resourceId, noteBlockId, html }) {
      //get necessary Id's
      if (!html) {
        throw 'no html field was provided for the updated noteblock html';
      }
      if (!noteBlockId) {
        throw 'no noteBlockId was provided for the noteblock you want to update';
      }
      if (!resourceId) {
        throw 'no resourceId was provided for the noteblock you want to update';
      }

      //create the update object
      const noteBlockUpdate = {};
      noteBlockUpdate[noteBlockId] = { content: { html } };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: resourceId, noteBlocks: noteBlockUpdate });
    },
    updateResourceRating({ dispatch }, { resourceId, rating }) {
      //make sure necessary items are sent
      if (!rating) {
        throw new Error('no noteBlockId was provided for the noteblock you want to update');
      }
      if (!resourceId) {
        throw new Error('no resourceId was provided for the noteblock you want to update');
      }

      //create the update object
      const update = { id: resourceId, rating };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', update);
    },
    updateResourceStatusForAuthor({ dispatch }, { resourceId, authorId, status }) {
      //make sure necessary items are sent
      if (!status) {
        throw new Error('no status was provided for the resource/author you want to update');
      }
      if (!authorId) {
        throw new Error('no authorId was provided for the resource you want to update');
      }
      if (!resourceId) {
        throw new Error('no resourceId was provided for the resource you want to update');
      }

      //create the update object
      const update = { id: resourceId, authors: {} };
      update.authors[authorId] = { status };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', update);
    },
    updateResourceTags({ state, rootState, dispatch }, { selectedTags, resourceId }) {
      //make sure necessary items are sent
      if (!selectedTags) {
        throw new Error('no selectedTags arrray was provided for the resource you want to update');
      }
      if (!resourceId) {
        throw new Error('no resourceId was provided for the resource you want to update');
      }
      //get the necessary items from store
      const myResource = state.resources[resourceId];
      const workspaceId = myResource.workspace;
      const workspace = rootState.workspaces[workspaceId];
      const workspaceTags = workspace.resourceTags;

      //create a new tags object which will contain all the tags for this and generate new Id's for any that are not currently in the workspace
      const tagsObject = {};
      selectedTags.forEach(selectedTag => {
        const tagOfInterest = workspaceTags.find(workspaceTag => workspaceTag.text === selectedTag);
        //if the tag doesn't exist in the workspace then create an id for it
        if (tagOfInterest === undefined) {
          const tagId = fb.resourcesCollection.doc().id;
          const newTagObj = {
            id: tagId,
            text: selectedTag
          };
          tagsObject[newTagObj.id] = newTagObj;
          //if it does exist in the workspace remove the un-needed resource array and update the resource tags with the id from the workspace
        } else {
          delete tagOfInterest.resources;
          tagsObject[tagOfInterest.id] = tagOfInterest;
        }
      });

      const update = { id: resourceId, tags: { userDefined: tagsObject } };
      dispatch('patch', update);
    },
    moveNoteBlocksByOrder({ dispatch, state }, { ordersToMove, moveLocation, resourceId }) {
      if (ordersToMove.constructor !== Array) {
        throw 'input ordersToMove was either not provided or is not an array please check your function inputs and try again';
      }
      if (isNaN(moveLocation)) {
        throw 'moveLocation was either not provided or is not a number please check your function inputs and try again';
      }
      if (resourceId == undefined) {
        throw 'input resourceId was either not provided or undefined please check your function inputs and try again';
      }

      //get the noteBlocks we are intersted in and convert them to an array
      const { resources } = state;
      const resource = resources[resourceId];
      const { noteBlocks } = resource;
      const noteBlocksArray = Object.values(noteBlocks);

      //user a helper to update the order on all of the elements
      const noteBlocksUpdate = helpers.moveHelper(ordersToMove, moveLocation, noteBlocksArray);
      console.log('noteBlocksUpdate', noteBlocksUpdate);

      //send the update to vuex and firestore
      if (Object.keys(noteBlocksUpdate).length !== 0) {
        dispatch('patch', { id: resourceId, noteBlocks: noteBlocksUpdate });
      } else {
        throw 'problems generating the update object please check that the moveLocation input value is not included in the ordersToMove Input Array';
      }
    },
    moveNoteBlocksById({ dispatch, state }, { idsToMove, moveLocation, resourceId }) {
      if (idsToMove.constructor !== Array) {
        throw 'input idsToMove was either not provided or is not an array please check your function inputs and try again';
      }
      if (isNaN(moveLocation)) {
        throw 'moveLocation was either not provided or is not a number please check your function inputs and try again';
      }
      if (resourceId == undefined) {
        throw 'input resourceId was either not provided or undefined please check your function inputs and try again';
      }

      //get the noteBlocks we are intersted in and convert them to an array
      const { resources } = state;
      const resource = resources[resourceId];
      const { noteBlocks } = resource;
      const noteBlocksArray = Object.values(noteBlocks);

      //get the orders of the provided id's from our helper function
      const ordersToMove = [];
      noteBlocksArray.forEach(noteBlock => {
        if (idsToMove.includes(noteBlock.id)) {
          ordersToMove.push(noteBlock.order);
        }
      });

      //order them using the move by order function
      dispatch('moveNoteBlocksByOrder', { ordersToMove, moveLocation, resourceId });
    },
    updateResourceText({ dispatch }, { resourceId, text, field = 'text' }) {
      //make sure necessary items are sent
      if (!text) {
        throw new Error('no text was provided');
      }
      if (!resourceId) {
        throw new Error('no resourceId was provided for the noteblock you want to update');
      }

      //create the update object
      const update = { id: resourceId };
      update[field] = text;

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', update);
    },
    updateResourceURL({ dispatch }, { resourceId, url }) {
      //make sure necessary items are sent
      if (!url) {
        throw new Error('no url was provided');
      }
      if (!resourceId) {
        throw new Error('no resourceId was provided for the noteblock you want to update');
      }

      //create the update object
      const update = { id: resourceId, resourceData: { url: url } };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', update);
    },
    updateResourceSource({}, { resource }) {
      console.log('fetch guest profiles');
      return new Promise((resolve, reject) => {
        //const url = fb.paths.functionLocal + 'urlToHTML';
        const url = fb.paths.function + 'urlToHTML';
        const resourceId = resource.id;
        const requestURL = resource.resourceData.url;
        axios
          .post(url, { requestURL, resourceId })
          .then(() => {
            console.log('updated');
            resolve(true);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};

export default resourcesModules;
